<template>
	<div v-cloak>
		<div id="main" class="container-fluid mb-5">

			<div class="row row-main">
				<div class="col-12 col-md-auto search-controls no-select">

					<div class="filter-switch-section" v-show="mobileOptions.showFilterButton" @click="showFiltersButtonClicked">
						<img class="svg-loader" src="/img/loaders/spinner-1s-200px-purple.svg" v-show="requestsActive" />
						<img class="svg-filter" src="/img/icons/filter.svg" v-show="!requestsActive" />
						<span v-show="!requestsActive">Show Filters</span>
					</div>

					<div class="control-sections" v-show="mobileOptions.showSearchControls">
						<div class="control-section control-section-top">
							<label class="form-label" :class="clsCollapsed(S_SEARCH)" @click="toggleSection(S_SEARCH)">Search Bundles</label>
							<div class="control-section-controls" v-show="showControlSection(S_SEARCH)">
								<input type="text" class="form-control search-input" placeholder="Search bundles..." ref="search-input" v-model="packageSearch.searchTerm" @input="debounceSearchPackagesPZ($event)" @keyup.enter="debounceSearchPackagesPZ($event)" :disabled="disableControls">
							</div>
						</div>
						<div class="control-section control-section-middle" v-show="containsNonZero(packageCounts.canva, packageCounts.photoshop)">
							<label class="form-label" :class="clsCollapsed(S_CTYPE)" @click="toggleSection(S_CTYPE)">Content Type</label>
							<div class="control-section-controls" v-show="showControlSection(S_CTYPE)">
								<div class="form-check" v-show="notZero(packageCounts.canva)">
									<input class="form-check-input" type="checkbox" :value="ptCanva" v-model="packageSearch.packageTypes" id="pt-canva" :disabled="disableControls" @change="searchPackagesPZ">
									<label class="form-check-label no-select" for="pt-canva">Canva ({{packageCounts.canva}})</label>
								</div>
								<div class="form-check" v-show="notZero(packageCounts.photoshop)">
									<input class="form-check-input" type="checkbox" :value="ptPhotoshop" v-model="packageSearch.packageTypes" id="pt-photoshop" :disabled="disableControls" @change="searchPackagesPZ">
									<label class="form-check-label no-select" for="pt-photoshop">Photoshop ({{packageCounts.photoshop}})</label>
								</div>
							</div>
						</div>
						<div class="control-section control-section-middle" v-show="containsNonZero(packageCounts.instagram, packageCounts.facebook)">
							<label class="form-label" :class="clsCollapsed(S_SMTYPE)" @click="toggleSection(S_SMTYPE)">Social Media</label>
							<div class="control-section-controls" v-show="showControlSection(S_SMTYPE)">
								<div class="form-check" v-show="notZero(packageCounts.instagram)">
									<input class="form-check-input" type="checkbox" :value="smInstagram" v-model="packageSearch.socialMediaTypeIDs" id="sm-instagram" :disabled="disableControls" @change="searchPackagesPZ">
									<label class="form-check-label no-select" for="sm-instagram">Instagram ({{packageCounts.instagram}})</label>
								</div>
								<div class="form-check" v-show="notZero(packageCounts.facebook)">
									<input class="form-check-input" type="checkbox" :value="smFacebook" v-model="packageSearch.socialMediaTypeIDs" id="sm-facebook" :disabled="disableControls" @change="searchPackagesPZ">
									<label class="form-check-label no-select" for="sm-facebook">Facebook ({{packageCounts.facebook}})</label>
								</div>
							</div>
						</div>
						<div class="control-section control-section-middle" v-show="containsNonZero(packageCounts.discounted, packageCounts.free)">
							<label class="form-label" :class="clsCollapsed(S_PRICE)" @click="toggleSection(S_PRICE)">Pricing</label>
							<div class="control-section-controls" v-show="showControlSection(S_PRICE)">
								<div class="form-check" v-show="notZero(packageCounts.discounted)">
									<input class="form-check-input" type="checkbox" v-model="packageSearch.discounted" id="pr-discounted" :disabled="disableControls" @change="searchPackagesPZ">
									<label class="form-check-label no-select" for="pr-discounted">Discounted ({{packageCounts.discounted}})</label>
								</div>
								<div class="form-check" v-show="notZero(packageCounts.free)">
									<input class="form-check-input" type="checkbox" v-model="packageSearch.free" id="pr-free" :disabled="disableControls" @change="searchPackagesPZ">
									<label class="form-check-label no-select" for="pr-free">Free ({{packageCounts.free}})</label>
								</div>
							</div>
						</div>
						<div class="control-section control-section-middle" v-show="notZeroPackagesInEach(imageCategories)">
							<label class="form-label" :class="clsCollapsed(S_CAT)" @click="toggleSection(S_CAT)">Categories</label>
							<div class="control-section-controls" v-show="showControlSection(S_CAT)">
								<div class="form-check" v-for="(imgCat, i) in imageCategories" v-show="notZero(getNrPackages(imgCat))">
									<input class="form-check-input" type="checkbox" :value="imgCat.id" v-model="packageSearch.imageCategoryIDs" :id="getImgCatCheckboxID(imgCat)" :disabled="disableControls" @change="searchPackagesPZ">
									<label class="form-check-label no-select" :for="getImgCatCheckboxID(imgCat)">{{imgCat.name}} ({{getNrPackages(imgCat)}})</label>
								</div>
							</div>
						</div>
						<div class="control-section control-section-bottom" v-show="showBundleLanguageSelection">
							<label class="form-label" :class="clsCollapsed(S_LAN)" @click="toggleSection(S_LAN)">Bundle Language</label>
							<div class="control-section-controls" v-show="showControlSection(S_LAN)">
								<select-box class="form-control language-select" :options="enumLanguage.byValue" value-prop="value" name-prop="description" v-model.number="idBundleLanguage" v-on:input="updateBundleLanguage($event)"></select-box>
							</div>
						</div>
					</div>

					<div class="show-results-section" v-show="mobileOptions.showResultsButton" @click="showResultsButtonClicked">
						<img class="svg-loader" src="/img/loaders/spinner-1s-200px-white.svg" v-show="requestsActive" />
						<span v-show="!requestsActive">Show {{pageOptions.nrRecords}} Bundles</span>
					</div>

				</div>

				<div class="col-12 col-md search-results" v-show="mobileOptions.showSearchResults">

					<div class="row row-paginator-top">
						<div class="col-paginator-top col-12">
							<paginator v-model="pageOptions.pageIndex" v-bind="pageOptions" :hide-paginator="false" @paginate="searchPackages" :disabled="requestsActive"></paginator>
						</div>
					</div>

					<div class="row row-container-packages no-select">
						<div class="col-container-package col-sm-12 col-lg-6 col-xl-4" v-for="(oPackage, i) in oPackages">
							<div class="container-package grow shadow">
								<a class="stylless-link" :href="oPackage.url" target="_blank">
									<div class="package-thumb">
										<img class="package-image" :src="getFeaturedImageUrl(oPackage)" :alt="getFeaturedImageAlt(oPackage)" :width="getFeaturedImageWidth(oPackage)" :height="getFeaturedImageHeight(oPackage)" loading="lazy" />
										<img class="icon-social-media" :src="getSocialMediaIconUrl(oPackage)" :title="getSocialMediaIconTitle(oPackage)" v-show="false" /> <!-- disabled because of trademark reasons -->
										<img class="icon-content-type" :src="getContentTypeIconUrl(oPackage)" :title="getContentTypeIconTitle(oPackage)" v-show="false" /> <!-- disabled because of trademark reasons -->
									</div>
									<div class="package-title">
										<span>{{oPackage.name}} - {{oPackage.actualNrTemplates}} Templates</span>
									</div>
									<div class="package-discount" v-show="isDiscountedAndUnowned(oPackage)">
										<timer :seconds="timerNrSeconds(oPackage)" @ended="timerEnded(oPackage)"></timer><span>&nbsp;-&nbsp;{{discountPercentage(oPackage)}} OFF!</span>
									</div>
									<div class="package-icons" v-show="false">
										<div class="package-icon" :title="getTitleNrDaysSincePublication(oPackage)">
											<img src="/img/packages/clock.svg" loading="lazy" />
											<span>{{oPackage.nrDaysSincePublication}}</span>
										</div>
										<div class="package-icon" :title="getTitleNrViews(oPackage)">
											<img src="/img/packages/eye.svg" loading="lazy" />
											<span>{{oPackage.nrViews}}</span>
										</div>
									</div>
									<div class="package-cta-button">
										<input type="button" :value="getTextSelectionButton(oPackage)" class="btn btn-primary cta-button">
									</div>
								</a>
							</div>
						</div>
					</div>

					<div class="row row-paginator-bottom" v-show="nonZeroResults">
						<div class="col-paginator-bottom col-12">
							<paginator v-model="pageOptions.pageIndex" v-bind="pageOptions" :hide-paginator="false" @paginate="searchPackages" :disabled="requestsActive"></paginator>
						</div>
					</div>

					<div class="overlay no-select" v-show="requestsActive">
						<div class="overlay-bg"></div>
						<div class="overlay-img"><img src="/img/loaders/spinner-1s-200px-purple.svg" /></div>
					</div>

				</div>

			</div> <!-- main row -->
		</div> <!-- container fluid -->
	</div> <!-- vue app -->
</template>




<script>
	// import components
	import paginator from './common/Paginator.vue';
	import selectBox from './common/SelectBox.vue';
	import timer from './common/Timer.vue';

	// constants
	const S_SEARCH = 0;
	const S_CTYPE  = 1;
	const S_SMTYPE = 2;
	const S_PRICE  = 3;
	const S_CAT    = 4;
	const S_LAN    = 5;

	const PAGESIZE    = 9; // todo: must also be set in PackageSearch.cs; make both depend on single setting, instead
	const MS_DEBOUNCE = 250;
	const MOBILE_BP   = 768;

	export default {
		mixins: [mixinAxios],
		components: {
			paginator,
			selectBox,
			timer
		},
		data: () => ({
			mobileOptions: {
				prevWidth : window.innerWidth,
				curWidth : window.innerWidth,
				mobileMode : true,
				showFilterButton : true,
				showResultsButton : false,
				showSearchControls : false,
				showSearchResults : true
			},
			pageOptions: {
				options: {
					texts: {
						countMultiPage: 'Showing {from} to {to} of {count} bundles.',
						countSinglePage: '{count} Bundles.',
						countSingleItem: '1 Bundle.'
					}
				},
				nrRecords: 0,
				pageSize: PAGESIZE,
				pageIndex: 0,
				pageSetSize: 10,
				disabled: false,
				hidePaginator: false
			},
			packageSearch: {
				/* do not change variable names
				 * they're used in the b64-encoded filter slug
				*/
				searchTerm: '',
				and: true,
				imageCategoryIDs: [],
				socialMediaTypeIDs: [],
				packageTypes: [],
				free: false,
				discounted: false,
				pageSize: PAGESIZE,
				pageIndex: 0
			},
			collapsedSections: {
				search : false,
				cType : false,
				smType: false,
				price : false,
				cat : false,
				lan : false
			},
			enumPackageType: {},
			enumSocialMediaType: {},
			enumLanguage: {},
			dicLanguage: {},
			idBundleLanguage: 0,
			imageCategories: [],
			oVisitorStatus: {},
			ownedPackageIDs: {},
			wListedPackageIDs: {},
			oPackages: [],
			packageCounts : {
				canva: 0,
				photoshop: 0,
				instagram: 0,
				facebook: 0,
				discounted: 0,
				free: 0
			}
		}),
		props: {
			modelPackageSearch : { type: Object, required: false, default: null }
		},
		created() {
			this.initAppropriateMode();
			this.initResizeTracker();
			this.initConstants();

		},
		mounted() {
			this.initPackageSearch(); // in mounted, so that paginator responds to pageIndex change
			this.initData().then(() => {
				this.searchPackages();
			});
		},
		methods: {
			initResizeTracker() {
				addEventListener('resize', (event) => {
					this.mobileOptions.curWidth = window.innerWidth;
				});
			},
			initConstants() {
				this.S_SEARCH = S_SEARCH;
				this.S_CTYPE  = S_CTYPE;
				this.S_SMTYPE = S_SMTYPE;
				this.S_PRICE  = S_PRICE;
				this.S_CAT    = S_CAT;
				this.S_LAN    = S_LAN;
			},
			getPackageSearchFromBase64Filter() {
				var b64Filter = common.getUrlSubDirByIndex(1);
				var result = common.fromCustomBase64(b64Filter);
				return (result.success)	? result.obj : null;
			},
			getPackageSearchFromModel() {
				return this.modelPackageSearch;
			},
			initPackageSearch() {
				var ps1 = this.getPackageSearchFromBase64Filter();
				var ps2 = this.getPackageSearchFromModel();

				if (ps1 != null) {
					this.packageSearch = ps1;
					this.pageOptions.pageIndex = ps1.pageIndex; // make paginator respond
				} else if (ps2 != null) {
					this.packageSearch = ps2;
					this.pageOptions.pageIndex = ps2.pageIndex; // make paginator respond
				}
			},
			initData() {
				return this.mixinAxios().get('/api/guest/GetPackagesSearchInfo')
					.then((result) => {
						var data                 = result.data;
						this.enumPackageType     = data.enumPackageType;
						this.enumSocialMediaType = data.enumSocialMediaType;
						this.enumLanguage        = data.enumLanguage;
						this.dicLanguage         = data.dicLanguage;
						this.idBundleLanguage    = data.bundleLanguageID;
						this.imageCategories     = data.imageCategories;
						this.oVisitorStatus      = data.visitorStatus;
						this.ownedPackageIDs     = data.ownedPackageIDs;
						this.wListedPackageIDs   = data.wListedPackageIDs;
					});
			},
			updateUrl() {
				var rootSlug = common.getUrlSubDirByIndex(0);
				var result   = common.toCustomBase64(this.packageSearch);

				var query = (result.success && (this.filtersNotCleared || this.pageIndexNotZero))
					? `/${rootSlug}/${result.b64}/`
					: `/${rootSlug}/`;

				history.replaceState({}, document.title, query);
			},
			updateBundleLanguage(event) {
				var params = { params : { idBundleLanguage : this.idBundleLanguage } };

				return this.mixinAxios().get('/api/guest/SetBundleLanguage', params)
					.then((resSetBundleLanguage) => {
						this.clearFilters();
						this.updateUrl();
						return this.searchPackagesPZ();
					});
			},
			_searchPackages(evt) {
				this.updateUrl();

				return this.mixinAxios().post('/api/guest/SearchPackagesPaginated', this.packageSearch)
					.then((result) => {
						var data                   = result.data;
						this.pageOptions.nrRecords = data.paginatedPackages.nrRecords;
						this.oPackages             = data.paginatedPackages.entities;
						this.packageCounts         = data.packageCounts;
						this.$refs['search-input'].focus();
					});
			},
			searchPackages(evt) {
				// the 'pageOptions.pageIndex' watcher does not update the packageSearch object quickly enough, so do it manually
				this.packageSearch.pageIndex = this.pageOptions.pageIndex;
				this._searchPackages();
			},
			searchPackagesPZ(evt) {
				// PZ = page zero
				this.pageOptions.pageIndex = 0;
				this.searchPackages(evt);
			},
			debounceSearchPackagesPZ(e) {
				var enter         = (e.key === 'Enter'); // keyup event
				var timeout       = (enter ? 0 : MS_DEBOUNCE);
				var debouncedFunc = common.debounce(this.searchPackagesPZ, timeout, false);
				debouncedFunc();
			},
			getImgCatCheckboxID(imgCat) {
				return `id-cb-cat-${imgCat.id}`;
			},
			getFeaturedImageUrl(oPackage) {
				var image = oPackage?.images[0];
				return common.versionedImageUrl(image?.img500Url, image?.imgOriSha1);
			},
			getFeaturedImageAlt(oPackage) {
				return oPackage?.name;
			},
			getFeaturedImageWidth(oPackage) {
				return oPackage?.images[0]?.img500Width;
			},
			getFeaturedImageHeight(oPackage) {
				return oPackage?.images[0]?.img500Height;
			},
			getPackageSocialMediaName(oPackage) {
				return this.enumSocialMediaType?.byValue?.[oPackage?.socialMediaTypeID].name ?? null;
			},
			getPackageContentTypeName(oPackage) {
				return this.enumPackageType?.byValue?.[oPackage?.type].name ?? null;
			},
			getSocialMediaIconUrl(oPackage) {
				var name = this.getPackageSocialMediaName(oPackage);

				switch (name) {
					case 'Instagram' : return '/img/icons/large/instagram.png';
					case 'Facebook'  : return '/img/icons/large/facebook.png';
					default          : return null;
				}
			},
			getContentTypeIconUrl(oPackage) {
				var name = this.getPackageContentTypeName(oPackage);

				switch (name) {
					case 'Canva'     : return '/img/icons/large/canva.png';
					case 'Photoshop' : return '/img/icons/large/photoshop.png';
					default          : return null;
				}
			},
			getSocialMediaIconTitle(oPackage) {
				var name = this.getPackageSocialMediaName(oPackage);

				switch (name) {
					case 'Instagram' : return 'Instagram bundle.';
					case 'Facebook'  : return 'Facebook bundle.';
					default          : return null;
				}
			},
			getContentTypeIconTitle(oPackage) {
				var name = this.getPackageContentTypeName(oPackage);

				switch (name) {
					case 'Canva'     : return 'Canva bundle.';
					case 'Photoshop' : return 'Photoshop bundle.';
					default          : return null;
				}
			},
			isOwned(oPackage) {
				return (this.ownedPackageIDs?.[oPackage?.id] != null);
			},
			isDiscounted(oPackage) {
				return (oPackage.activeDiscountPeriod != null);
			},
			discountTimeLeft(oPackage) {
				return (this.timerNrSeconds(oPackage) > 0);
			},
			isDiscountedAndUnowned(oPackage) {
				var unOwned    = !this.isOwned(oPackage);
				var discounted = this.isDiscounted(oPackage);
				var timeLeft   = this.discountTimeLeft(oPackage);

				return (unOwned && discounted && timeLeft);
			},
			discountPercentage(oPackage) {
				var percentage = (this.isDiscounted(oPackage))
					? 100 - ((oPackage.activeDiscountPeriod.nrCredits / oPackage.nrCredits) * 100)
					: 0;

				var nrDecs = percentage?.countDecimals()?.rangeCap(0, 2) ?? 0;
				return (percentage != null) ? `${percentage.toFixedNumber(nrDecs)}%` : '';
			},
			timerNrSeconds(oPackage) {
				return (this.isDiscounted(oPackage))
					? common.getNrSecsUntilSerializedUtcEnd(oPackage.activeDiscountPeriod?.end)
					: 0;
			},
			timerEnded(oPackage) {
				oPackage.activeDiscountPeriod = null;
			},
			getTitleNrDaysSincePublication(oPackage) {
				var strDays = (oPackage.nrDaysSincePublication == 1) ? 'day' : 'days';
				return `This package was published ${oPackage.nrDaysSincePublication} ${strDays} ago.`;
			},
			getTitleNrViews(oPackage) {
				return `This package has been viewed ${oPackage.nrViews} times.`;
			},
			getTextSelectionButton(oPackage) {
				var loggedOut        = !this.isLoggedIn;
				var owned            = this.isOwned(oPackage);
				var nrCreditsPackage = oPackage?.actualNrCredits ?? 0;
				var zeroCredits      = (nrCreditsPackage == 0);

				return (loggedOut)
					? `$${nrCreditsPackage.toNrDecimals(2, 2)}` // logged out
					: (owned)
						? 'YOU OWN THIS' // owned
						: (zeroCredits)
							? 'FREE' // free
							: `$${nrCreditsPackage.toNrDecimals(2, 2)}`; // logged in, not free, not owned
			},
			toggleSection(section) {
				if (section == this.S_SEARCH) {
					this.collapsedSections.search = !this.collapsedSections.search;
				}
				if (section == this.S_CTYPE) {
					this.collapsedSections.cType = !this.collapsedSections.cType;
				}
				if (section == this.S_SMTYPE) {
					this.collapsedSections.smType = !this.collapsedSections.smType;
				}
				if (section == this.S_PRICE) {
					this.collapsedSections.price = !this.collapsedSections.price;
				}
				if (section == this.S_CAT) {
					this.collapsedSections.cat = !this.collapsedSections.cat;
				}
				if (section == this.S_LAN) {
					this.collapsedSections.lan = !this.collapsedSections.lan;
				}
			},
			clsCollapsed(section) {
				return {
					'collapsed' :
						((section == this.S_SEARCH) && (this.collapsedSections.search)) ||
						((section == this.S_CTYPE) && (this.collapsedSections.cType)) ||
						((section == this.S_SMTYPE) && (this.collapsedSections.smType)) ||
						((section == this.S_PRICE) && (this.collapsedSections.price)) ||
						((section == this.S_CAT) && (this.collapsedSections.cat)) ||
						((section == this.S_LAN) && (this.collapsedSections.lan))
				};
			},
			showControlSection(section) {
				switch (section)
				{
					case this.S_SEARCH : return !this.collapsedSections.search;
					case this.S_CTYPE : return !this.collapsedSections.cType;
					case this.S_SMTYPE : return !this.collapsedSections.smType;
					case this.S_PRICE : return !this.collapsedSections.price;
					case this.S_CAT : return !this.collapsedSections.cat;
					case this.S_LAN : return !this.collapsedSections.lan;
				}
			},
			setAppropriateMode(mobile) {
				var prevWidth = this.mobileOptions.prevWidth;
				var curWidth  = this.mobileOptions.curWidth;

				if (mobile) {
					//console.log(`mobile (${prevWidth} -> ${curWidth})`);
					this.mobileOptions.mobileMode = true;
					this.mobileOptions.showFilterButton = true;
					this.mobileOptions.showResultsButton = false;
					this.mobileOptions.showSearchControls = false;
					this.mobileOptions.showSearchResults = true;
				} else { // desktop
					//console.log(`desktop (${prevWidth} -> ${curWidth})`);
					this.mobileOptions.mobileMode = false;
					this.mobileOptions.showFilterButton = false;
					this.mobileOptions.showResultsButton = false;
					this.mobileOptions.showSearchControls = true;
					this.mobileOptions.showSearchResults = true;
				}
			},
			switchToAppropriateMode() {
				var prevWidth = this.mobileOptions.prevWidth;
				var curWidth  = this.mobileOptions.curWidth;
				var toMobile  = ((curWidth < MOBILE_BP) && (prevWidth >= MOBILE_BP));
				var toDesktop = ((curWidth >= MOBILE_BP) && (prevWidth < MOBILE_BP));

				if (toMobile) {
					this.setAppropriateMode(true);
				} else if (toDesktop) {
					this.setAppropriateMode(false);
				}
			},
			initAppropriateMode() {
				var mobile = (this.mobileOptions.curWidth < MOBILE_BP);
				this.setAppropriateMode(mobile);
			},
			showFiltersButtonClicked() {
				this.mobileOptions.showFilterButton = false;
				this.mobileOptions.showResultsButton = true;
				this.mobileOptions.showSearchControls = true;
				this.mobileOptions.showSearchResults = false;
			},
			showResultsButtonClicked() {
				this.mobileOptions.showFilterButton = true;
				this.mobileOptions.showResultsButton = false;
				this.mobileOptions.showSearchControls = false;
				this.mobileOptions.showSearchResults = true;
			},
			notZero(count) {
				return (count > 0);
			},
			containsNonZero(...numbers) {
				return numbers.some(number => number !== 0);
			},
			notZeroPackagesInEach(imgCats) {
				var sum = 0;

				for (var i = 0; i < imgCats.length; i++) {
					var imgCat = imgCats[i];
					sum += this.getNrPackages(imgCat);
				}

				return sum;
			},
			getNrPackages(imgCat) {
				var tagUpper = this.dicLanguage?.[this.idBundleLanguage]?.tagUpper ?? '';
				var prop = `nrPackages_${tagUpper}`;
				return imgCat[prop];
			},
			clearFilters() {
				var ps                = this.packageSearch;
				ps.and                = true;
				ps.discounted         = false;
				ps.free               = false;
				ps.socialMediaTypeIDs = [];
				ps.imageCategoryIDs   = [];
				ps.packageTypes       = [];
				ps.searchTerm         = '';
			}
		},
		computed: {
			ptCanva() {
				return this.enumPackageType?.byName?.canva?.value ?? 0;
			},
			ptPhotoshop() {
				return this.enumPackageType?.byName?.photoshop?.value ?? 0;
			},
			smInstagram() {
				return this.enumSocialMediaType?.byName?.instagram?.value ?? 0;
			},
			smFacebook() {
				return this.enumSocialMediaType?.byName?.facebook?.value ?? 0;
			},
			hasAccount() {
				return this.oVisitorStatus.hasAccount;
			},
			isLoggedIn() {
				return this.oVisitorStatus.isLoggedIn;
			},
			disableControls() {
				return false; // this.requestActive;
			},
			filtersCleared() {
				var ps = this.packageSearch;

				return (ps)
					? (ps.and && !ps.discounted && !ps.free && ps.socialMediaTypeIDs.length == 0 && ps.imageCategoryIDs.length == 0 && ps.packageTypes.length == 0 && ps.searchTerm == '')
					: true;
			},
			filtersNotCleared() {
				return !this.filtersCleared;
			},
			pageIndexNotZero() {
				return ((this.packageSearch?.pageIndex ?? 0) != 0);
			},
			nonZeroResults() {
				var nrPackages = (this.oPackages?.length ?? 0);
				return (nrPackages > 0);
			},
			showBundleLanguageSelection() {
				var lanProps = Object.keys(this.dicLanguage);
				return (lanProps.length > 1);
			}
		},
		watch: {
			'pageOptions.pageSize'(newVal, oldVal) {
				this.packageSearch.pageSize = newVal;
			},
			'pageOptions.pageIndex'(newVal, oldVal) {
				this.packageSearch.pageIndex = newVal;
			},
			'mobileOptions.curWidth'(newVal, oldVal) {
				this.mobileOptions.prevWidth = oldVal;
				this.switchToAppropriateMode();
			}
		}
	}
</script>




<style scoped>
	[v-cloak] {
		display: none;
	}

	#main {
		max-width: 1600px;
		margin: auto;
	}

	.search-controls {
		border: 0px solid black;
		width: 250px;
		width: 75%;
		margin : 0px auto;
		padding : 0px 0px;
	}

	.search-input:focus {
		box-shadow: 0 0 0 0.25rem rgba(67, 56, 202, 0.25);
		border:1px solid rgb(206, 212, 218);
	}

	.language-select:focus {
		box-shadow: 0 0 0 0.25rem rgba(67, 56, 202, 0.25);
		border:1px solid rgb(206, 212, 218);
	}

	.search-results {
		border: 0px solid black;
		margin-top:25px;
		position:relative;
		min-height:250px;
	}

	.search-results::before {
		content: "";
		background: #e0e7ff;
		position: absolute;
		width: 75%;
		border-radius: 20px;
		top: 0px;
		left: 0px;
		right: 0px;
		margin: auto;
		height: 100%;
		z-index: -1;
	}

	.control-section {
		border: 0px solid gray;
		padding: 12px 12px;
		background: #e0e7ff;
		position:relative;
	}

	.control-section:first-child {
		margin-top:0px;
	}

	.control-section-top {
		border-top-left-radius:20px;
		border-top-right-radius:20px;
	}

	.control-section-middle {
	}

	.control-section-bottom {
		border-bottom-left-radius:20px;
		border-bottom-right-radius:20px;
	}

	.control-section-middle::before, .control-section-bottom::before {
		content: "";
		background: #32658b;
		position: absolute;
		top: 0px;
		left: 10px;
		right: 10px;
		height: 1px;
	}

	.control-header {
		font-weight: bold;
		margin-bottom: 5px;
	}

	.control-section-controls {
		margin-top:0.5rem;
	}

	.filter-switch-section {
		border:2px solid rgb(67,56,202);
		background: rgb(224,231,255);
		border-radius: 20px;
		display:flex;
		align-items:center;
		justify-content:center;
		padding:4px;
		cursor:pointer;
	}

	.filter-switch-section img.svg-loader {
		height: 24px;
	}

	.filter-switch-section img.svg-filter {
		height: 14px;
	}

	.filter-switch-section span {
		margin-left:5px;
	}

	.show-results-section {
		background: rgb(67,56,202);
		border-radius: 20px;
		display:flex;
		align-items:center;
		justify-content:center;
		padding:4px;
		position:fixed;
		width:80%;
		bottom:2.5%;
		left:50%;
		transform:translateX(-50%);
		z-index:1000;
		color:white;
		font-size:1rem;
		cursor:pointer;
		padding:8px;
	}

	.show-results-section:hover {
		background: rgb(57,48,172);
	}

	.show-results-section img.svg-loader {
		height:24px;
	}

	.show-results-section span {
		margin-left:5px;
	}

	.form-label {
		font-weight: bold;
		display:block;
		position:relative;
		cursor:pointer;
		margin-bottom:0px;
	}

	.form-label::after {
		background: url(/img/gfx/chevron_black.svg) no-repeat center/6px 10px;
		content: "";
		height: 10px;
		margin-top: -5px;
		position: absolute;
		right: 0;
		top: 50%;
		transform: rotate(-90deg);
		width: 10px;
	}

	.form-label.collapsed {
		opacity:0.5;
	}

	.form-label.collapsed::after {
		transform: rotate(90deg);
		opacity:0.5;
	}

	.form-check input, .form-check label {
		cursor: pointer;
	}

	.row-paginator-top {
		margin-top:20px;
		margin-bottom:0px;
	}

	.row-paginator-bottom {
		margin-top:20px;
		margin-bottom:30px;
	}

	.row-main {
		margin: 0;
	}

	@media all and (min-width: 768px)
	{
		.search-controls {
			width: auto;
			margin : 0px 0px;
			padding : 0px 12px;
		}

		.control-section::first-child {
			margin-top:0px;
		}

		.search-results {
			margin-top:0px;
		}
	}




	/* OVERLAY */

	.overlay {
		position:absolute;
		top:0px;
		left:0px;
		width:100%;
		height:100%;
	}

	.overlay-bg {
		position:absolute;
		top:0px;
		left:0px;
		width:100%;
		height:100%;
		background:black;
		opacity:0.1;
		z-index:10;
		border-radius:20px;
	}

	.overlay-img {
		position:absolute;
		top:0px;
		left:0px;
		width:100%;
		height:100%;
		z-index:20;
		display:flex;
		align-items:center;
		justify-content:center;
		border-radius:20px;
	}

	.overlay-img img {
	}

	/* OVERLAY */




	/* PACKAGE */

	.row-container-packages {
		position:relative;
	}

	.col-container-package {
		border:0px solid black;
		margin-bottom: 50px;
	}

	.container-package {
		border: 1px solid transparent;
		border-radius: 15px;
		padding: 0px 13px;
		background: white;
		margin-top:50px;
	}

	.package-thumb {
		border: 0px solid purple;
		margin-top: -20px;
		position:relative;
	}

	.package-thumb img.package-image {
		object-fit: contain;
		width: 100%;
		height: 100%;
		border-radius: 15px;
	}

	.package-thumb img.icon-social-media {
		width:7.5%;
		position:absolute;
		bottom:3%;
		left:3%;
		opacity:1;
	}

	.package-thumb img.icon-content-type {
		width:7.5%;
		position:absolute;
		bottom:3%;
		right:3%;
		opacity:1;
	}

	.package-title {
		border: 0px solid red;
		display: flex;
		justify-content: center;
		margin-top: 4px;
	}

	.package-title span {
		font-weight: bold;
	}

	.package-discount {
		display: flex;
		justify-content: center;
		align-content: center;
		font-weight: bold;
		margin-top: 0px;
		color: red;
		text-align: center;
	}

	.package-icons {
		border: 0px solid green;
		display: flex;
		justify-content: space-between;
	}

	.package-icon {
		border: 0px solid cyan;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.package-icon span {
		margin-left: 10px;
	}

	.package-cta-button {
		border: 0px solid black;
		display: flex;
		justify-content: center;
		margin: 5px auto -25px auto;
	}

	.cta-button {
		border: 0px solid black;
		height: 50px;
		color: white;
		font-size: 1.2em;
		font-weight: normal;
		padding: 10px 25px;
		transition: 0.15s;
	}

	.cta-button:hover {
		/* background: #1299FD; */
	}

	.cta-button:focus, .cta-button:active {
		outline: none !important;
		box-shadow: none !important;
	}

	a.stylless-link {
		color: inherit;
		text-decoration: inherit;
	}

	.shadow {
		-webkit-box-shadow: 0px 7px 20px -6px rgba(0,0,0,0.25);
		-moz-box-shadow: 0px 7px 20px -6px rgba(0,0,0,0.25);
		box-shadow: 0px 7px 20px -6px rgba(0,0,0,0.25);
	}

	.grow {
		transition: all .3s ease;
	}

	.grow:hover {
		transform: scale(1.03);
	}

	@media all and (max-width: 991px) {
		.grow:hover {
			transform: scale(1.03);
		}
	}

	/* PACKAGE */

</style>